import React from 'react';
import './ErrorBoundary.scss';
import Error from './error.png';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false, errorMessage: {
                error: null,
                errorInfo: null,
            }
        };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.log(error, errorInfo);
        this.setState({
            errorMessage: {
                error: error,
                errorInfo: errorInfo,
            }
        })
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="error-boundary">
                    <img src={Error} />
                    <h1>Some error has occured</h1>
                    <p>{JSON.stringify(this.state.errorMessage.error)} - {JSON.stringify(this.state.errorMessage.errorInfo)}</p>
                    <button onClick={() => {
                        this.setState({
                            hasError: false,
                        })
                        window.location.reload();
                    }}>Retry</button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;